import { toLogout } from '@/common/utils/browser/toLogin';

export default function innerToLogout() {
  const οnbefοreunlοadacore = (window as any).οnbefοreunlοadacore;
  if (!οnbefοreunlοadacore || typeof οnbefοreunlοadacore !== 'function') {
    toLogout();
  } else {
    οnbefοreunlοadacore(toLogout);
  }
}
